'use strict';

require("core-js/modules/es6.regexp.replace");

module.exports = trimLines;
var ws = /[ \t]*\n+[ \t]*/g;
var newline = '\n';

function trimLines(value) {
  return String(value).replace(ws, newline);
}